import { render, staticRenderFns } from "./PendingCollaborationRequests.vue?vue&type=template&id=e123ce78&scoped=true&"
import script from "./PendingCollaborationRequests.vue?vue&type=script&lang=js&"
export * from "./PendingCollaborationRequests.vue?vue&type=script&lang=js&"
import style0 from "./PendingCollaborationRequests.vue?vue&type=style&index=0&id=e123ce78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e123ce78",
  null
  
)

export default component.exports